<template>
  <!-- 团队信用使用记录 -->
  <div class="app-container">
    <searchForm
      ref="form"
      :searchData="queryParams"
      :searchForm="searchForm"
      :searchHandle="searchHandle"
    ></searchForm>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="first"></el-tab-pane>
      <el-tab-pane label="调额" name="second"></el-tab-pane>
      <el-tab-pane label="消费" name="third"></el-tab-pane>
      <el-tab-pane label="退款" name="fourth"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="tableData"
      :empty-text="'暂无记录'"
      height="600"
      :header-cell-style="{ background: '#F5F5F5' }"
    >
      <el-table-column
        prop="title"
        label="发生事件"
        align="center"
      ></el-table-column>
      
      <el-table-column prop="money" label="金额" align="center">
        <template slot-scope="scope">
          ¥{{ scope.row.money || "0.00" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="addDate"
        label="发生时间"
        align="center"
      ></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"/>
    </el-table>
    <!-- <el-pagination
      style="text-align: right;margin-top: 10px"
      v-if="total > 0"
      background 
      layout="total,prev, pager, next,sizes,jumper"
      :current-page="queryParams.pageNum"
      :page-size="queryParams.pageSize" 
      :total="total" 
      @current-change="selPageChange"
      @size-change="handleSizeChange">
    </el-pagination> -->
  </div>
</template>

<script>
import searchForm from "@/components/searchItem";
import { getFinancialCenterLogList } from "@/api/request";
import { getClient } from "@/plugins/auth";
export default {
  name: "",
  props: {},
  components: {
    searchForm,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        orderByColumn: 'addDate',
        isAsc: 'desc',
        sfFileName: undefined,
        startTime: undefined,
        endTime: undefined,
        timerange: [],
      },
      total: 0,
      tableData: [],
      userInfo: JSON.parse(getClient()),
      activeName: "first",
      searchForm: [
        {
          type: "daterange",
          prop: "timerange",
          width: "120px",
          startPlaceholder: "开始时间",
          endPlaceholder: "结束时间",
        },
        {
          type: "Input",
          prop: "addName",
          placeholder: "操作人",
        },
        {
          type: "Input",
          prop: "checkName",
          placeholder: "检测名称",
        },
        {
          type: "Input",
          prop: "orderCode",
          placeholder: "订单号",
        },
      ],
      searchHandle: [
        { label: "查询", type: "primary", handle: this.getLogList },
      ],
    };
  },
  mounted() {
    this.getLogList();
  },
  methods: {
    async getLogList(typeList) {
      let queryParams = {
        ...this.queryParams,
        teamId: this.userInfo.teamId,
        typeList:typeList ? typeList : [6,7,8,9],
        orderCode: this.queryParams.orderCode,
        checkName: this.queryParams.checkName,
        addName: this.queryParams.addName,
        startDate: this.queryParams.timerange ? this.queryParams.timerange[0] : undefined,
        endDate: this.queryParams.timerange ? this.queryParams.timerange[1] : undefined
      }
      const res = await getFinancialCenterLogList(queryParams)
      this.tableData = res.rows
      this.total = res.total
    },
    selPageChange(page) {
      this.queryParams.pageNum = page;
      this.getLogList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getLogList();
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      if(tab.index == '1'){
        this.getLogList([9])
      }else if(tab.index == '2'){
        this.getLogList([6,7])
      }else if(tab.index == '3'){
        this.getLogList([8])
      }else{
        this.getLogList()
      }
    },
  },
};
</script>

<style lang='scss' scoped>
</style>